import { Fragment } from "react";

import { Box, Paper, Typography, useTheme } from "@mui/material";
import { ChartsLabelMark, ChartsTooltipContainer, ChartsTooltipProps, useAxesTooltip } from "@mui/x-charts";

import { getUnitValueLabel } from "~/utils/unitUsageHelpers";
import { UsageOverTime } from "./DashboardPPTCharts";

const UsageOverTimeTooltip = ({
  hideExpectedUsage,
  unitLabel = "",
  usageOverTime,
  ...props
}: ChartsTooltipProps & { hideExpectedUsage?: boolean; unitLabel: string; usageOverTime: UsageOverTime }) => {
  const theme = useTheme();
  const axesTooltipData = useAxesTooltip();

  if (!usageOverTime) {
    return null;
  }

  const { axisFormattedValue, seriesItems } = axesTooltipData?.[0] || {};

  return (
    <ChartsTooltipContainer {...props}>
      <Paper>
        <Box alignItems="center">
          <Box alignItems="center" display="grid" gridTemplateColumns="auto 1fr auto" px={2} sx={{ gridColumnGap: theme.spacing(3) }}>
            {seriesItems?.map((item) => {
              const { color, formattedValue, seriesId, markType, value } = item;

              return (
                <Fragment key={seriesId}>
                  <ChartsLabelMark color={color} type={markType} />
                  <Typography sx={{ display: "inline-block" }}>{`${axisFormattedValue}`}</Typography>
                  <Typography sx={{ display: "inline-block" }}>{getUnitValueLabel(formattedValue, unitLabel, value)}</Typography>
                </Fragment>
              );
            })}
            {!hideExpectedUsage && (
              <>
                <ChartsLabelMark color={theme.palette.error.main} type="line" />
                <Typography sx={{ display: "inline-block" }}>Expected Usage</Typography>
                <Typography sx={{ display: "inline-block" }}>{getUnitValueLabel(usageOverTime.forecast.actual, unitLabel)}</Typography>
              </>
            )}
          </Box>
        </Box>
      </Paper>
    </ChartsTooltipContainer>
  );
};

export default UsageOverTimeTooltip;
